import React, { Component } from 'react';
import ElectionWidget from '../electionWidget/electionWidget';
import Api from '../../api';
import { Spinner } from '../spinner';
import { getProp } from '../../utilities';

class Election extends Component {
  constructor(props) {
    super(props);

    this.state = {
      staticData: {
        data: {},
        isFetching: false,
      },
    };

    this.renderElectionWidget = this.renderElectionWidget.bind(this);
    this.filterKosiceDistricts = this.filterKosiceDistricts.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        staticData: {
          ...this.state.staticData,
          isFetching: true,
        },
      },
      async () => {
        try {
          const data = await Api.get('/election/static-data');
          this.setState({
            staticData: {
              ...this.state.staticData,
              isFetching: false,
              data,
            },
          });
        } catch (e) {
          this.setState({
            error: getProp(e, 'message', ''),
            isFetching: false,
          });
        }
      },
    );
  }

  filterKosiceDistricts() {
    return getProp(this.state.staticData.data, 'kosice', []);
  }

  filterDistrictsDataWithoutKosice() {
    return getProp(this.state.staticData.data, 'districts', []).filter(
      district =>
        district.name !== 'Košice I' &&
        district.name !== 'Košice II' &&
        district.name !== 'Košice III' &&
        district.name !== 'Košice IV',
    );
  }

  renderElectionWidget() {
    if (getProp(this.state, 'error', '') === 'Not Found') {      
      return <h2>Volebné dáta momentálne nie sú dostupné!</h2>;
    }

    const { hideUpdateTime } = this.props;
    switch (this.props.widgetType) {
      case 'slovakia': {
        return (
          <ElectionWidget
            type="slovakia"
            header="Slovensko"
            staticData={this.state.staticData}
            hideUpdateTime={hideUpdateTime}
          />
        );
      }
      case 'region': {
        return (
          <ElectionWidget
            type="region"
            header="Kraj"
            staticData={getProp(this.state.staticData.data, 'regions', [])}
            id="8"
            hideUpdateTime={hideUpdateTime}
          />
        );
      }
      case 'district': {
        return (
          <ElectionWidget
            type="district"
            header="Okres"
            staticData={this.filterDistrictsDataWithoutKosice()}
            id="101"
            hideUpdateTime={hideUpdateTime}
          />
        );
      }
      case 'kosice': {
        return (
          <ElectionWidget
            type="kosice"
            header="Košice"
            staticData={this.filterKosiceDistricts()}
            hideUpdateTime={hideUpdateTime}
          />
        );
      }

      default: {
        return (
          <div>
            <ElectionWidget
              type="slovakia"
              header="Slovensko"
              staticData={this.state.staticData}
              hideUpdateTime={hideUpdateTime}
            />
            <ElectionWidget
              type="region"
              header="Kraj"
              staticData={getProp(this.state.staticData.data, 'regions', [])}
              id="8"
              hideUpdateTime={hideUpdateTime}
            />
            <ElectionWidget
              type="kosice"
              header="Košice"
              id={null}
              staticData={this.filterKosiceDistricts()}
              hideUpdateTime={hideUpdateTime}
            />
            <ElectionWidget
              type="district"
              header="Okres"
              staticData={this.filterDistrictsDataWithoutKosice()}
              id="806"
              hideUpdateTime={hideUpdateTime}
            />            
          </div>
        );
      }
    }
  }

  render() {
    return (
      <Spinner show={this.state.isFetching}>
        {this.renderElectionWidget()}
      </Spinner>
    );
  }
}

export default Election;



// WEBPACK FOOTER //
// ./src/ui/src/component/election/election.js